
import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useFormContext, Controller } from "react-hook-form";
import { useTranslate } from "src/locales";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";

export const NeedsSection = () => {
  const { t } = useTranslate();
  const { control } = useFormContext();

  const needsList = [
    { name: "needsAndPractices.religiousAndCulturalNeeds", label: "child-patient-assessment.religious-and-cultural-needs", desc: "needsAndPractices.religiousAndCulturalNeedsDescription" },
    { name: "needsAndPractices.privacyRequest", label: "child-patient-assessment.privacy-request", desc: "needsAndPractices.privacyRequestDescription" },
    { name: "needsAndPractices.specialCoveringPreference", label: "child-patient-assessment.special-covering-preference", desc: "needsAndPractices.specialCoveringPreferenceDescription" },
    { name: "needsAndPractices.specialDressingPreference", label: "child-patient-assessment.special-dressing-preference", desc: "needsAndPractices.specialDressingPreferenceDescription" },
  ];

  return (
    <Box
      sx={{
        border: "1px solid #DBDBDB",
        borderRadius: "4px",
        padding: "20px",
        width: "100%",
        marginTop: "20px",
      }}
    >
      <Grid container spacing={2}>
        {needsList.map((need) => (
          <Grid key={need.name} md={3} xs={6}>
            <Grid container direction="row" alignItems="center">
              <Grid md={2}>
                <Controller
                  name={need.name}
                  control={control}
                  render={({ field }) => (
                    <ByzMuiCheckBox
                      {...field}
                      checked={!!field.value}
                      onChange={(e) => field.onChange(e.target.checked)}
                    />
                  )}
                />
              </Grid>
              <Grid md={10}>
                <ByzMuiTypography>{t(need.label)}</ByzMuiTypography>
              </Grid>
            </Grid>
            <Box sx={{ mt: 1 }}>
              <Controller
                name={need.desc}
                control={control}
                render={({ field }) => (
                  <ByzMuiTextField {...field} multiline rows={2} sx={{ pt: 1 }} />
                )}
              />
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
